// D45 Item 4 — trajectory-preview point thinning (pure, no THREE). The charge preview is drawn as
// instanced dot markers flying the true 3D arc. This picks which flight points become dots: every point
// up to `max`, striding only beyond it, and ALWAYS keeping the APEX (highest point) and the final
// (landing) point so the arc reads and the ring lands where the ball will.

/** z-accessor so the apex is preserved even when callers pass {x,y,z} in various shapes. */
export function selectTrajectoryDots<T extends { z: number }>(points: readonly T[], max = 48): T[] {
  if (points.length === 0) return [];
  if (points.length <= max) return [...points]; // dense: one dot per flight point
  const stride = Math.ceil(points.length / max);
  const out: T[] = [];
  const chosen = new Set<number>();
  for (let i = 0; i < points.length && out.length < max; i += stride) {
    out.push(points[i]!);
    chosen.add(i);
  }
  // guarantee the apex (max z) and the final point survive the thinning
  let apex = 0;
  for (let i = 1; i < points.length; i++) if (points[i]!.z > points[apex]!.z) apex = i;
  for (const idx of [apex, points.length - 1]) {
    if (chosen.has(idx)) continue;
    if (out.length < max) out.push(points[idx]!);
    else out[out.length - 1] = points[idx]!; // replace the tail to make room at the cap
    chosen.add(idx);
  }
  return out;
}
